import { Navbar } from "@vionixasia/shared-components";
import { Footer } from "../layout/Footer";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export const Layout = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Tampilkan Navbar & Footer di semua halaman kecuali halaman peta (live, event map, map, device)
  const isMapPage = pathname.startsWith("/live") || pathname.startsWith("/event/") || pathname.startsWith("/map/") || pathname.startsWith("/device/");
  const hasFlushHero = pathname === "/";
  const showNavAndFooter = !isMapPage && pathname !== "/Login";

  // Smooth-scroll ke section di landing; jika sedang di halaman lain,
  // pindah ke "/" + hash dulu lalu scroll setelah render.
  const scrollToSection = (id) => () => {
    if (pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${id}`);
    }
  };

  const menuItems = [
    { label: "Home", to: "/" },
    { label: "Tracking Package", onClick: scrollToSection("about") },
    { label: "Contact", onClick: scrollToSection("contact") },
  ];

  return (
    <div className={`flex flex-col w-full ${isMapPage ? "h-screen" : "min-h-screen"}`}>
      {/* Navbar */}
      {showNavAndFooter && (
        <Navbar appName="TRACKING" menuItems={menuItems} hideUserName={true} />
      )}

      {/* Konten utama */}
      <main className={`flex-1 w-full ${isMapPage ? "overflow-hidden" : (!hasFlushHero ? 'pt-12' : '')}`}>
        <Outlet />
      </main>

      {/* Footer */}
      {showNavAndFooter && (
        <div className="w-full flex-shrink-0">
          <Footer />
        </div>
      )}
    </div>
  );
};
